import type { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import type { RedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoListDropdown } from "@redotech/redo-web/arbiter-components/list/redo-list-dropdown";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useState } from "react";
import { useSetPriorityConversationAction } from "../actions/use-conversation-actions";
import type { ConversationPriority } from "./badges/conversation-badges";
import { ConversationTicketFieldTitle } from "./conversation-ticket-field-title";

const priorityItems: RedoListItem<ConversationPriority | null>[] = [
  { type: "text", id: "none", text: "None", value: null },
  {
    type: "badge",
    id: "urgent",
    badge: { color: "error", text: "Urgent" },
    value: "CRITICAL",
  },
];

export const PrioritySelector = memo(function PrioritySelector({
  conversationId,
  priority,
}: {
  conversationId: ConversationId;
  priority: ConversationPriority | null;
}) {
  const setPriority = useSetPriorityConversationAction();
  const [badgeRef, setBadgeRef] = useState<HTMLElement | null>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const isUrgent = priority === "CRITICAL";

  return (
    <Flex align="center" gap="xs" justify="space-between">
      <ConversationTicketFieldTitle>Priority</ConversationTicketFieldTitle>
      <Flex
        onClick={() => setDropdownOpen((open) => !open)}
        ref={setBadgeRef}
        style={{ cursor: "pointer" }}
      >
        {isUrgent ? (
          <RedoBadge color="error" shadow size="sm" text="Urgent" />
        ) : (
          <RedoBadge color="gray" shadow size="sm" text="+" />
        )}
      </Flex>
      <RedoListDropdown
        dropdownAnchor={badgeRef}
        dropdownOpen={dropdownOpen}
        fitToAnchor={false}
        items={priorityItems}
        itemSelected={({ item }) => {
          void setPriority.execute(conversationId, item.value);
          setDropdownOpen(false);
        }}
        selectedItems={isUrgent ? "urgent" : "none"}
        selectionVariant="none"
        setDropdownOpen={setDropdownOpen}
        size="xs"
      />
    </Flex>
  );
});
